export default {
  name: 'CreditCardLogo',
  props: {
    cardtype: {
      type: [Number, String],
      default: 0
    },
    size: {
      type: String,
      default: 'lg'
    }
  },
  computed: {
    cardLogoImage() {
      return '/img/cc/' + this.size + '/' + this.cardtype + '.png';
    }
  }
};